/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Steps_OverlineInputs */

const en_dr_steps_overline = /** @type {(inputs: Dr_Steps_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method`)
};

const id_dr_steps_overline = /** @type {(inputs: Dr_Steps_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metode`)
};

/**
* | output |
* | --- |
* | "Method" |
*
* @param {Dr_Steps_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_steps_overline = /** @type {((inputs?: Dr_Steps_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Steps_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_steps_overline(inputs)
	return en_dr_steps_overline(inputs)
});